import Api from 'services/Api';
import _ from 'lodash';

// Mutation Types
const mutationTypes = {
    UPDATE: 'UPDATE',
    RESULT: 'RESULT',
    RESET: 'RESET'
};

// Initial State
const state = {
    gender: 'male',
    dateOfBirth: null,
    retirementAge: null,
    retirementDate: null,
};

// Getters
const getters = {
    value: state => key => state[key],
};

// Actions
const actions = {
    update({commit}, {key, value}) {
        commit(mutationTypes.UPDATE, {key, value});
    },
    calcRetirementAge: _.debounce(({dispatch, state}) => {
        let person = {
            gender: state.gender,
            dateOfBirth: state.dateOfBirth
        };
        return Api.calculators.dates.statePensionAge(person)
            .then(data => dispatch('result', data));
    }, 500),
    result({commit}, data) {
        commit(mutationTypes.RESULT, data);
    },
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.RESULT](state, data) {
        state.retirementAge = data.statePension.retirementAge;
        state.retirementDate = data.statePension.retirementDate;
    },
    [mutationTypes.RESET](state) {
        state.gender = 'male';
        state.dateOfBirth = null;
        state.retirementAge = null;
        state.retirementDate = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/retirementAge.js